// Import types from domain types package
import type { ServiceOption, BudgetOption } from '@tasama/types/domain';

// DropdownOption type definition
interface DropdownOption {
  value: string;
  label: string;
}

type TFunction = (_key: string) => string;

export const serviceOptions: ServiceOption[] = [
  {
    id: 'finance_accounting',
    value: 'Finance & Accounting Services',
    label: 'serviceNeeds.services.finance_accounting',
  },
  { id: 'hr', value: 'HR Services', label: 'serviceNeeds.services.hr' },
  {
    id: 'incubation',
    value: 'Incubation Services',
    label: 'serviceNeeds.services.incubation',
  },
  {
    id: 'innovation',
    value: 'Innovation Management Services',
    label: 'serviceNeeds.services.innovation',
  },
  {
    id: 'marketing',
    value: 'Marketing & Event Services',
    label: 'serviceNeeds.services.marketing',
  },
  {
    id: 'digital_tech',
    value: 'Digital & Technology Services',
    label: 'serviceNeeds.services.digital_tech',
  },
  {
    id: 'corporate',
    value: 'Corporate Property Services',
    label: 'serviceNeeds.services.corporate',
  },
  {
    id: 'soft_landing',
    value: 'Business Landing Services',
    label: 'serviceNeeds.services.soft_landing',
  },
  {
    id: 'company_builder',
    value: 'Company Builder Services',
    label: 'serviceNeeds.services.company_builder',
  },
  {
    id: 'legal',
    value: 'Legal Services',
    label: 'serviceNeeds.services.legal',
  },
  {
    id: 'pmo_as_service',
    value: 'PMO-as-a-Service',
    label: 'serviceNeeds.services.pmo_as_service',
  },
  {
    id: 'technology',
    value: 'Technology Operations',
    label: 'serviceNeeds.services.technology',
  },
];

export const getEngagementOptions = (t: TFunction): DropdownOption[] => [
  { value: '3_months', label: t('serviceNeeds.engagementOptions.3_months') },
  {
    value: '6_12_months',
    label: t('serviceNeeds.engagementOptions.6_12_months'),
  },
  {
    value: 'gt_12_months',
    label: t('serviceNeeds.engagementOptions.gt_12_months'),
  },
  { value: 'not_sure', label: t('serviceNeeds.engagementOptions.not_sure') },
];

export const getBudgetOptions = (t: TFunction): BudgetOption[] => [
  { value: 'yes', label: t('serviceNeeds.budget.yes') },
  { value: 'no', label: t('serviceNeeds.budget.no') },
];

export const getEstablishmentTimeframeOptions = (
  t: TFunction
): DropdownOption[] => [
  { value: '3_months', label: t('serviceNeeds.establishmentOptions.3_months') },
  {
    value: '6_12_months',
    label: t('serviceNeeds.establishmentOptions.6_12_months'),
  },
  {
    value: 'gt_12_months',
    label: t('serviceNeeds.establishmentOptions.gt_12_months'),
  },
  { value: 'not_sure', label: t('serviceNeeds.establishmentOptions.not_sure') },
];

export type { DropdownOption };
